import styled from 'styled-components';
import { normalize, withModifiers } from 'utils/styles';

export const Row = styled.div<{
  alignCenter?: boolean;
  spaceBetween?: boolean;
}>`
  display: flex;
  flex-direction: row;
  ${withModifiers('spaceBetween')`
    justify-content: space-between;
  `}
  ${withModifiers('alignCenter')`
    align-items: center;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${withModifiers('spaceBetween')`
    justify-content: space-between;
  `}
`;

export const WithMarginComponent = styled.span`
  display: inherit;
  margin: ${({ margin = '' }) => {
    return margin
      .split(' ')
      .map((value) => normalize(value))
      .join(' ');
  }};

  ${({ top }) => (top ? 'margin-top:' + normalize(top) : '')};
  ${({ right }) => (right ? 'margin-right:' + normalize(right) : '')};
  ${({ bottom }) => (bottom ? 'margin-bottom:' + normalize(bottom) : '')};
  ${({ left }) => (left ? 'margin-left:' + normalize(left) : '')};
  ${({ height = '' }) => (height ? 'height:' + height : '')};
`;

export const VerticalGap = styled.div`
  height: ${({ gap }: { gap: number }) => normalize(gap)};
`;

export const HorizontalGap = styled.div`
  width: ${({ gap }: { gap: number }) => normalize(gap)};
`;
